import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Toast } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { FlowerCheck } from 'baby-design/icons'
import { registryPath } from 'lib/urls'
import { Registry } from 'src/types/registry'
import { UnmarkedAsPurchasedToastProps } from './UnmarkedAsPurchasedToast.types'
import css from './UnmarkedAsPurchasedToast.styles.scss'

const toastCtaProps = (registry: Registry | undefined) =>
  registry
    ? {
        href: registryPath(registry.urlSlug),
        text: 'View registry',
      }
    : undefined

const UnmarkedAsPurchasedToast: React.FC<UnmarkedAsPurchasedToastProps> = ({
  handleDismiss,
  isOpen,
  registry,
  text,
}) => (
  <Toast
    dismissible
    cta={toastCtaProps(registry)}
    imageProps={{
      image: (
        <FlowerCheck
          filled
          dangerouslyOverrideClassName={css.UnmarkedAsPurchasedToast__Image}
        />
      ),
    }}
    isOpen={isOpen}
    text={text}
    variant="basic"
    onDismiss={handleDismiss}
  />
)

export default UnmarkedAsPurchasedToast
